export const V1_RECEIVE_SEAT_TRADE = 'V1_RECEIVE_SEAT_TRADE'

export default data => {
  return {
    type: V1_RECEIVE_SEAT_TRADE,
    data,
  }
}
